import { connect } from 'react-redux';
import { ConfigCatProvider } from 'configcat-react';
import { PollingMode, User } from 'configcat-common';
import type { IAutoPollOptions } from 'configcat-common';

import { RootState } from 'appRedux/store/rootReducer';
import * as authSelectors from 'appRedux/auth/selectors';

type ConfigCatProviderProps = {
  sdkKey: string;
  pollingMode?: PollingMode;
  options?: IAutoPollOptions;
};

const connector = connect<ConfigCatProviderProps, void, ConfigCatProviderProps, RootState>((state, ownProps) => {
  const user = authSelectors.getBasicUserInfo(state.auth);
  return {
    ...ownProps,
    pollingMode: PollingMode.AutoPoll,
    options: {
      ...ownProps.options,
      pollIntervalSeconds: 5 * 60, // every 5 minute
      defaultUser: new User(user?.email || 'anonymous', user?.email),
    },
  };
});

export default connector(ConfigCatProvider);
